import React from 'react';

interface LinkedInIconProps {
  className?: string;
}

function LinkedInIcon({ className }: LinkedInIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
      <g fill="currentColor" clipPath="url(#clip0)">
        <path d="M13.996 14H14V8.864c0-2.512-.54-4.447-3.477-4.447-1.412 0-2.36.775-2.746 1.51h-.04V4.651H4.951V14h2.9V9.371c0-1.219.23-2.397 1.74-2.397 1.486 0 1.508 1.39 1.508 2.475V14zM.231 4.653h2.903V14H.23V4.653zM1.681 0C.753 0 0 .753 0 1.681s.753 1.697 1.681 1.697 1.681-.769 1.681-1.697S2.61 0 1.682 0z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h14v14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default LinkedInIcon;
